import { useContext } from "react";
import { TrackingContext } from "../../Contexts/TrackingContext/TrackingContext";


const useNavigationState = () => {

    const { toggleNavigatingState, isNavigating, } = useContext(TrackingContext)



    return {
        isNavigating,
        showNavigation: () => toggleNavigatingState(true),
        hideNavigation: () => toggleNavigatingState(false)
    };
};

export default useNavigationState;